import { render, staticRenderFns } from "./ArrowCompare.vue?vue&type=template&id=16257b39&"
import script from "./ArrowCompare.vue?vue&type=script&lang=js&"
export * from "./ArrowCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports